import { ChangeDetectionStrategy, Component, input, OnInit, signal, ViewChild, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PayErrorResponse } from 'projects/login/src/app/services/auth/models/pay-error-response';
import { TwoFaService } from 'projects/login/src/app/services/auth/two-fa.service';
import { copyBalloonButtonDirective } from 'projects/login/src/app/utils/copy-balloon-button/copy-balloon-button.directive';
import { ButtonPrimaryComponent } from '../../button-primary/button-primary.component';
import { ErrorBadgeComponent } from '../../error-badge/error-badge.component';
import { IconComponent } from '../../pay-icon/icon.component';
import { IconNames } from '../../pay-icon/IconNames';
import { PinEntryComponent } from '../../pin-entry/pin-entry.component';
import { SpinnerComponent } from '../../spinner/spinner.component';

@Component({
  selector: 'pay-login-setup-two-factor-auth-app',
  imports: [
    copyBalloonButtonDirective,
    ReactiveFormsModule,
    PinEntryComponent,
    TranslateModule,
    ButtonPrimaryComponent,
    ErrorBadgeComponent,
    SpinnerComponent,
    IconComponent,
  ],
  templateUrl: './setup-two-factor-auth-app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetupTwoFactorAuthAppComponent implements OnInit {
  private readonly _twoFaService = inject(TwoFaService);

  @ViewChild('pinEntryComponent') pinEntry!: PinEntryComponent;

  mfaBearer = input.required<string>();
  twoFaCode = signal('');
  twoFaImage = signal('');
  isSubmitting = signal(false);
  loading = signal(true);
  error = signal<undefined | PayErrorResponse>(undefined);
  qrError = signal<undefined | PayErrorResponse>(undefined);

  protected readonly IconNames = IconNames;

  ngOnInit(): void {
    this._twoFaService.generateQr(this.mfaBearer()).subscribe({
      next: (response) => {
        this.twoFaCode.set(response.otpSecret);
        this.twoFaImage.set(response.qr);
        this.loading.set(false);
      },
      error: (error) => {
        this.loading.set(false);
        this.qrError.set(error.error as PayErrorResponse);
      },
    });
  }

  submitPinEntry() {
    this.pinEntry.disabled.set(true);
    this.isSubmitting.set(true);

    this._twoFaService.twoFaSetup({ method: 'otp' }).subscribe({
      next: () => {
        this._twoFaService
          .verify({
            value: this.pinEntry.pinValues().join(''),
            rememberFor: null,
          })
          .subscribe({
            next: (response) => {
              window.location.href = response.redirectUrl;
            },
            error: (err) => {
              this.error.set(err.error as PayErrorResponse);

              this.isSubmitting.set(false);
            },
          });
      },
      error: (err) => {
        this.error.set(err.error as PayErrorResponse);

        this.isSubmitting.set(false);
      },
    });

    this.pinEntry.disabled.set(false);
  }
}
